
bam-tab-component {

  bal-tabs {
    .grid.is-multiline {
      margin: 0 !important;
    }

    bal-select, bal-dropdown {
      margin-bottom: 1.5rem;
    }

    nav > ul {
      position: relative;
    }
  }

  .bal-tabs-item {
    display: block !important;
    visibility: visible;
		z-index: 0;
		transition: opacity 0.7s ease-in-out, transform 0.4s ease-in-out;
		transform: translateY(0);
		top: 0;

		&:not(.is-active) {
			overflow: hidden;
			visibility: hidden;
			transform: translateY(80px);
			max-height: 0;
			opacity: 0;
			z-index: -1;
			top: 100%;
    }

    &.is-active {
      bal-list {
        margin-top: -16px;
      }
    }
  }

  .column.is-one-third.bal-tabs__col-items.bal-tabs__col-items--vertical {
    padding-left: 0 !important;

    @include mobile() {
      padding-right: 0 !important;
    }
  }

  .column.bal-tabs__col-content.bal-tabs__col-content--vertical {
    @include mobile() {
      padding-left: 0 !important;
      padding-right: 0 !important;
    }
  }

  bal-tab-item {
    // &.is-active {
    //   width: 100% !important;

    //   @include desktop() {
    //     width: 75% !important;
    //   }
    // }

    bam-contact-teaser {
      padding-left: 0 !important;
      padding-right: 0 !important;
    }
  }
}
